import { Layout } from "./components/layout";
import { Routes,Route } from "react-router-dom";
import {Home} from "./pages/home"
import {About} from "./pages/about"
import {Portfolio} from "./pages/portfolio"
import {News} from "./pages/news"
import {Contact} from "./pages/contact"
import { useRef } from "react";
import {Color} from "./components/color"
import "./i18n/config"

function App() {
  const app = useRef()
  return (
    <div ref={app} className="App">
      <Layout>
        <Routes>
          <Route path="/" element={<Home reference={app}/>}/>
          <Route path="/about" element={<About reference={app}/>}/>
          <Route path="/portfolio" element={<Portfolio reference={app}/>}/>
          <Route path="/news" element={<News reference={app}/>}/>
          <Route path="/contact" element={<Contact reference={app}/>}/>
        </Routes>
      </Layout>
      <Color/>
    </div>
  );
}

export default App;
